import React, { createElement } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-[#f0f5ed] relative overflow-hidden" data-id="element-196">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#e8dcc8]/20 to-transparent pointer-events-none" data-id="element-197" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-198">
        <div className="max-w-6xl mx-auto" data-id="element-199">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-200">
            {/* Product Image Column */}
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative" data-id="element-201">
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform hover:scale-[1.02] transition-transform duration-500" data-id="element-202">
                <img src="https://cdn.magicpatterns.com/uploads/gZPhbKigRidpoDz6wx2f6k/ChatGPT_Image_Jan_11,_2026,_05_21_59_PM.png" alt="El Milagro del Sobre - Libro y recursos digitales" className="w-full h-auto object-cover" data-id="element-203" />
              </div>

              {/* Decorative elements behind image */}
              <div className="absolute -bottom-6 -right-6 w-full h-full bg-[#1a3d3d]/10 rounded-2xl -z-10" data-id="element-204" />
              <div className="absolute -top-10 -left-10 w-40 h-40 bg-[#f4c430]/20 rounded-full blur-3xl -z-10" data-id="element-205" />
            </motion.div>

            {/* Content Column */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="flex flex-col justify-center" data-id="element-206">
              <div className="inline-block px-4 py-1 bg-[#1a3d3d]/10 text-[#1a3d3d] font-bold rounded-full text-sm mb-6 mx-auto" data-id="element-207">
                OFERTA ESPECIAL DE LANZAMIENTO
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-[#1a3d3d] mb-6 leading-tight text-center" data-id="element-208">
                Empieza tu transformación{' '}
                <span className="text-[#f4c430]" data-id="element-209">hoy mismo</span>
              </h2>

              <p className="text-xl text-slate-600 mb-8" data-id="element-210">
                Todo lo que necesitas para dejar de sufrir por dinero y empezar
                a construir la vida que mereces, en un sistema simple y visual.
              </p>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-[#e8dcc8] mb-8 relative overflow-hidden" data-id="element-211">
                <div className="absolute top-0 right-0 bg-[#f4c430] text-[#1a3d3d] text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-212">
                  DESCUENTO LIMITADO
                </div>

                <div className="flex items-end gap-4 mb-6" data-id="element-213">
                  <div className="text-6xl font-bold text-[#1a3d3d] leading-none" data-id="element-214">
                    $6.39
                  </div>
                  <div className="text-xl text-slate-400 line-through mb-2 font-medium" data-id="element-215">
                    $47.00
                  </div>
                </div>

                <ul className="space-y-3 mb-8" data-id="element-216">
                  {['E-book completo "El Milagro del Sobre"', 'Acceso inmediato al sistema completo', 'Todos los métodos y estrategias', 'Formato digital', 'PDF descargable para imprimir', 'Funciona en celular, tablet y computadora', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-217">
                      <Check size={20} className="text-[#1a3d3d] mt-0.5 flex-shrink-0" strokeWidth={3} data-id="element-218" />
                      <span className="text-slate-700" data-id="element-219">{item}</span>
                    </li>)}
                </ul>

                <a href="https://instaflowdp.com/cart/62947483746673:1" target="_blank" rel="noopener noreferrer" onClick={() => {
                // Fire Meta Pixel AddToCart event before navigation
                if (typeof window !== 'undefined' && window.fbq) {
                  window.fbq('track', 'AddToCart');
                }
              }} className="inline-flex items-center justify-center font-heading font-bold rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gradient-to-b from-[#f4c430] via-[#f4c430] to-[#d4a428] text-black shadow-[0_8px_16px_rgba(0,0,0,0.3),0_4px_8px_rgba(244,196,48,0.4)] hover:shadow-[0_10px_20px_rgba(0,0,0,0.4),0_6px_12px_rgba(244,196,48,0.5)] border-t border-[#ffd93d]/50 hover:translate-y-[-2px] active:translate-y-[1px] active:shadow-[0_4px_8px_rgba(0,0,0,0.3)] px-8 py-4 text-lg w-full text-center" data-id="element-220">
                  Si, Quiero Transformar Mi Vida Financiera
                </a>

                <div className="mt-4 flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-221">
                  <ShieldCheck size={16} className="text-[#1a3d3d]" data-id="element-222" />
                  <span data-id="element-223">Pago 100% seguro y encriptado</span>
                </div>
              </div>

              <p className="text-center text-slate-500 text-sm italic" data-id="element-224">
                "La mejor inversión que harás por menos de lo que cuesta una
                pizza."
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}